module.exports = __webpack_public_path__ + "b1fc3cfe4ac4b95ae904744e827014a1.png";